  /*
 	Zoom 1.7.20
 	license: MIT
 	http://www.jacklmoore.com/zoom
 */
 (function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,r,a,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(a=c,r=u):(a=d.outerWidth(),r=d.outerHeight()),m=(e.width-c)/a,l=(e.height-u)/r,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,r),0),t=Math.max(Math.min(t,a),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),r=document.createElement("img"),a=o(r),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,r.onload=null,a.remove()}.bind(this,i.style.position,i.style.overflow)),r.onload=function(){function t(t){f.init(),f.move(t),a.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(r):!1)}function n(){a.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(r):!1)}var f=o.zoom(i,u,r,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(r)},r.setAttribute("role","presentation"),r.src=e.url})},o.fn.zoom.defaults=t})(window.jQuery);

/**
 * Minified by jsDelivr using Terser v5.7.1.
 * Original file: /gh/phucbm/flickity-responsive@1.1.0/flickity-responsive.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!function(t){t.fn.flickityResponsive=function(e){const i=t(this);new ResponsiveObject({object:e,onMatched:t=>{void 0!==typeof i.flickity?(void 0!==i.data("flickity")&&i.flickity("destroy"),i.flickity(t.object),i.flickity("resize")):console.warn("Flickity is undefined!")}})}}(jQuery);class ResponsiveObject{constructor(t){if(this.object=t.object||void 0,!this.object||!this.object.responsive)return!1;this.onMatched=t.onMatched||function(){},this.onUpdate=t.onUpdate||function(){},this.isInherit=void 0===t.isInherit||t.isInherit,this.currentObject={breakpoint:void 0,object:{}},this.object.responsive=this.getSortedArray(this.object.responsive),this.match(),window.addEventListener("resize",(()=>{this.match()}))}match(){let t=!1;for(let e=0;e<this.object.responsive.length;e++){const i=this.object.responsive[e];if(t=matchMedia(this.getQuery(e)).matches,t){this.currentObject.breakpoint!==i.breakpoint&&(this.currentObject={type:"responsive",lastBreakpoint:this.currentObject.breakpoint,breakpoint:i.breakpoint,object:this.mergeObject(i.breakpoint,i.settings)},"function"==typeof this.onMatched&&this.onMatched(this.currentObject));break}}t||-1===this.currentObject.breakpoint||(this.currentObject={type:"default",lastBreakpoint:this.currentObject.breakpoint,breakpoint:-1,object:this.mergeObject(-1,this.object)},"function"==typeof this.onMatched&&this.onMatched(this.currentObject)),"function"==typeof this.onUpdate&&this.onUpdate(this.currentObject)}getQuery(t){let e=`screen and (max-width:${this.object.responsive[t].breakpoint}px)`;const i=this.object.responsive[t+1];return i&&(e+=` and (min-width:${i.breakpoint+1}px)`),e}getSortedArray(t,e=!0){const i=[...t];return e?i.sort(((t,e)=>t.breakpoint<e.breakpoint?1:-1)):i.sort(((t,e)=>t.breakpoint>e.breakpoint?1:-1)),i}mergeObject(t,e){let i={...e};if(this.isInherit&&-1!==t){const e=this.getSortedArray(this.object.responsive,!1);for(let n=0;n<e.length;n++)e[n].breakpoint>t&&(i={...e[n].settings,...i})}return i={...this.object,...i},delete i.responsive,i}}
//# sourceMappingURL=/sm/aaeb749e872f3332161b06441f2b49106e1c65bfe006bb3577fef361294dd541.map

/*==================================================
STICKY SHIPPING BAR WITH STICKY HEADER 
=================================================== */
 $(document).ready(function(){
setTimeout(function(){
  if($('body').children('#fsb_background') ){
    $('#fsb_background').css({"position":"fixed", "z-index":"1000"});
    $('.navigation--sticky').css('top','44px');
    
    $(window).scroll(function () {  

      if($(window).scrollTop() > 200) {
        $('#fsb_background').css({"position":"fixed", "z-index":"1000"});
        $('.navigation--sticky').css('top','44px');
        $('body').addClass('sticky-fsb-top');
       
      }
      else if ($(window).scrollTop() <= 100) {
        $('#fsb_background').css('position','relative');
        $('.navigation--sticky').css('top','');
        $('body').removeClass('sticky-fsb-top');
       
      }  
    });   
  }
},2000);
    
   
   
    if($(".template-product .product-media-container").length){
        var elements = document.querySelectorAll(".template-product .product-media-container");
      
      
        if ( window.matchMedia("(max-width: 740px)").matches ) {
          return false;
        }


        elements.forEach(function (element) {
          var src = element.querySelector("img"),
              src = src.getAttribute("data-zoom-src"),
              src = src.replace("{width}", "1000");

          $(element).zoom({
            magnify: 2,
            target: '.zoom-box',
            url: src
          });

          $(element).hover(function () {
            $('.product-gallery-controls').show();
            $('.product-gallery-controls').hide();
          });

          $(element).mouseover(function () {
            $('.zoom-box').show();
          });

          $(element).mouseout(function () {
            $('.zoom-box').hide();
          });
        });
    }   
   
   
});

$( window ).on("load", function() {
  if($("#related_popup_container").length){
        $("#related_popup_container .upsell-product-recommendations-loop").slick({
          dots: true,
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
  }
  
  });


// $(function() {
//   $('.picZoomer').picZoomer();

//   $('.piclist .product-single__thumbnail').on('click',function(event){
//     var $pic = $(this).find('img').attr("data-zoom-src") ;
//     //alert($pic);
//     $('.picZoomer-pic').attr('src',$pic);
//   });
// });


/*==================================================
          START: STICKY ADD TO CART
=================================================== */
$(document).ready(function () {
    if($('.Addtocart__container').length){
       var elementPosition = $('.Addtocart__container').offset();
        $(window).scroll(function(){
  	  if($(window).scrollTop() > elementPosition.top){
            $('body').addClass('CartBtn__is-sticky');
            $('.product__section-contentWrapper').addClass('cart-btn-sticky');          
            $('.sticky-cart-btn__container').addClass("cart-btn-sticky__onScroll");             
        }
         else{
          $('.sticky-cart-btn__container').removeClass("cart-btn-sticky__onScroll");
          $('.product__section-contentWrapper').removeClass("cart-btn-sticky");
          $('body').removeClass('CartBtn__is-sticky');
      }
      });
    }
  });
/*==================================================
          END: STICKY ADD TO CART
=================================================== */

/*==================================================
            START:  LOGO CROUSEL
=================================================== */
if($('.logo-carousel__container').length){
    $('.logo-carousel__container').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true,
      dots: false,
      prevArrow: '<button class="slick-prev slick-arrow logo-carousel__arrow" aria-label="Previous" type="button" style="display: block;"><svg class="slick-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow logo-carousel__arrow" aria-label="Next" type="button" style="display: block;"><svg class="slick-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        pauseOnHover: false,
        responsive: [
        {
          breakpoint: 1024,
          settings: {
          slidesToShow: 4
          }
        },
        {
          breakpoint: 768,
          settings: {
          slidesToShow: 3
          }
        }, 
        {
          breakpoint: 499,
          settings: {
          slidesToShow: 2
          }
        }
      ]
    });
} 
  
/*==================================================
           END: LOGO CROUSEL
=================================================== */

/*==================================================
           START: Store pickup Show/Hide

$(document).ready(function () {
  $(document).on("click","#show_hide__storepickup",function() {
     if($('#show_hide__storepickup').is(":checked")){  
        var DateInputElement = $(".storepickup__date-container").find('#store_pickup_data_selector');
      
       DateInputElement.removeAttr('disabled');
       DateInputElement.val('');
           $('body').addClass('in-store-pickup__available');
           $('body').find('#checkout').addClass('disabled');
           $('body').find('#checkout').attr('disabled','disabled');
       
           if ($.trim(DateInputElement.val()) == null ) {     
              // console.log('cc');
             $(".storepickup__date-container").find('#store_pickup_selector').val('No');
             $('body').find('#checkout').removeClass('disabled');
             $('body').find('#checkout').removeAttr('disabled');
            }else{
             //  $(this).submit();
             $(".storepickup__date-container").find('#store_pickup_selector').val('Yes');
            } 
             DateInputElement.on("input", function() {
               if($(this).val()  != null ){
                 $('body').find('#checkout').removeClass('disabled');
                 $('body').find('#checkout').removeAttr('disabled');
               }               
            });
    
      } else{     
       var DateInputElement = $(".storepickup__date-container").find('#store_pickup_data_selector');
        DateInputElement.val('');
        DateInputElement.attr('disabled','disabled');
       $(".storepickup__date-container").find('#store_pickup_selector').val('No');
       $('body').removeClass('in-store-pickup__available');   
       $('body').find('#checkout').removeClass('disabled');
       $('body').find('#checkout').removeAttr('disabled');
       
      }
  });
});

           END: Store pickup Show/Hide
=================================================== */

 // $(document).ready(function(){
 //   $.get("https://ipinfo.io", function (response) {
 //        //console.log(response.ip + "IP Addresss" + response.country +" " +response.region+ "  "+ response.city );
 //    if(response.country == "US"){
 //        if (response.city == "Florida") {
 //          //console.log(response.ip + "IP Addresss Florida "+ response.city );
 //          $('body').addClass('in-store-pickup__available');
 //        }
 //    }
     
 //     }, "jsonp");
 // });


document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.jdgm-carousel-wrapper img, .headerBadge__Desktop img, .footer_badget img, .product-added__image').forEach(function(img) {
    img.setAttribute('width', '100%');
    img.setAttribute('height', '100%');
  });

  document.querySelectorAll('.jdgm-carousel__item-wrapper .jdgm-carousel-item__review .jdgm-carousel-item__review-body p').forEach(function(paragraph) {
    // Find all <br> tags within each paragraph and remove them
    paragraph.querySelectorAll('br').forEach(function(br) {
        br.remove();
    });
  });
});

jQuery(document).ready(function(){
  jQuery('.slideout__trigger-mobile-menu').on('click', function(){
    jQuery('.slideout__drawer-left').show();
  });
});



/*==========================================================================
             START: PRODUCT PAGE PAYMENTS INSTALLMENT MODAL
=========================================================================== */
var product_payment_modal = document.getElementById("product-payments-popup-container");
if(product_payment_modal){
    var btn = document.getElementById("product__payments__pop-trigger");    
    var product_payment_modal_close = product_payment_modal.querySelector(".modal-close");
    var payment_modal_close_btn = product_payment_modal.querySelector('.modal-close-btn');
    
    btn.onclick = function() {
      product_payment_modal.style.display = "block";
      document.querySelector('body').classList.add('no-scroll');
    }
    
    product_payment_modal_close.onclick = function() {
      product_payment_modal.style.display = "none";
      document.querySelector('body').classList.remove('no-scroll');
    }
    payment_modal_close_btn.onclick = function() {
      product_payment_modal.style.display = "none";
      document.querySelector('body').classList.remove('no-scroll');
    }
    window.onclick = function(event) {
      if (event.target == product_payment_modal) {
        product_payment_modal.style.display = "none";
        document.querySelector('body').classList.remove('no-scroll');
      }
    }
}
/*==========================================================================
             END: PRODUCT PAGE PAYMENTS INSTALLMENT MODAL
=========================================================================== */



/*==========================================================================
             START: PRODUCT PAGE EXPECTED DELIVERY DATE CALCULATE
=========================================================================== */
$(document).ready(function(){  
      var someDate = new Date();   
      var someDateAddInstock = new Date(); 
      var someDateAddInstockDelivery = new Date(); 
      var someDateAddInstockDeliveryRange = new Date(); 
      let var_today_day = someDate.getDay()
                               
      //var numberOfDaysToAdd = Number($(".get_est_days").text());  
      //var numberOfDaysToAddInstock = Number($(".get_instock_days").text());

      var numberOfDaysToAddInstockDelivery = Number($("#get-expected-delivery-days").text());
      //alert(numberOfDaysToAddInstockDelivery);
      if(var_today_day == 5){
          //numberOfDaysToAdd = numberOfDaysToAdd + 2;
          //numberOfDaysToAddInstock = numberOfDaysToAddInstock + 2;
          numberOfDaysToAddInstockDelivery = numberOfDaysToAddInstockDelivery + 2;
      }else if(var_today_day == 6){
          //numberOfDaysToAdd = numberOfDaysToAdd + 1;
          //numberOfDaysToAddInstock = numberOfDaysToAddInstock + 1;
          numberOfDaysToAddInstockDelivery = numberOfDaysToAddInstockDelivery + 1;
      }
  
      //someDate.setDate(someDate.getDate() + numberOfDaysToAdd);   
      //someDateAddInstock.setDate(someDateAddInstock.getDate() + numberOfDaysToAddInstock); 
      var numberOfDaysToAddInstockDeliveryRange = numberOfDaysToAddInstockDelivery + 2;
      someDateAddInstockDelivery.setDate(someDateAddInstockDelivery.getDate() + numberOfDaysToAddInstockDelivery); 
      someDateAddInstockDeliveryRange.setDate(someDateAddInstockDeliveryRange.getDate() + numberOfDaysToAddInstockDeliveryRange); 

      var myDate = someDate;

      var month=new Array();
      month[0]="January";
      month[1]="February";
      month[2]="March";
      month[3]="April";
      month[4]="May";
      month[5]="June";
      month[6]="July";
      month[7]="August";
      month[8]="September";
      month[9]="October";
      month[10]="November";
      month[11]="December";
      var hours = myDate.getHours();
      var minutes = myDate.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ampm;

      //var today = myDate.getDate()+" "+month[myDate.getMonth()]+" "+myDate.getFullYear();
  	  var today = myDate.getDate()+" "+month[myDate.getMonth()];
  
      var today_Instock = someDateAddInstock.getDate()+" "+month[someDateAddInstock.getMonth()];

      var today_InstockDelivery = someDateAddInstockDelivery.getDate()+" "+month[someDateAddInstockDelivery.getMonth()];
      var today_InstockDeliveryRange = someDateAddInstockDeliveryRange.getDate()+" "+month[someDateAddInstockDeliveryRange.getMonth()];
  
  	  //$("#estimated-ship-instock_date").val(today_Instock);
      //$("#estimated-instock_delivery_day_date").val(today_InstockDelivery);      
  	  $(".expected-delivery-date-display").text(today_InstockDelivery+' - '+today_InstockDeliveryRange);
      $("#expected-delivery-date").val(today_InstockDelivery);
  
  	  //$("#shipping_date_display").text("Get it by "+today);        
      // setTimeout(function() { 
      //     $(".estimated_day_shipping_date_block").text("");
      //     $(".esti_ship_input").each(function(){
      //         if($(this).is(':disabled')){                   
                  
      //         }else{
      //             var get_value_ship_date_item = $(this).val();                
      //             var get_value_ship_date_item_label = $(this).attr("data-esti-ship-name");                
                  
      //             //alert(get_value_ship_date_item);
      //             $(".estimated_day_shipping_date_block").append('<p>'+get_value_ship_date_item_label+': '+get_value_ship_date_item+'</p>');
      //         }
            
      //     });         
      // }, 2000);    
  
});     
                        

/*==========================================================================
           END: PRODUCT PAGE EXPECTED DELIVERY DATE CALCULATE
=========================================================================== */